import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";
import banner1 from '../assets/banners/banner1.jpg';
import banner2 from '../assets/banners/banner2.jpg';
import banner3 from '../assets/banners/banner3.png';

import re1 from '../assets/re1.jpeg';
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaArrowCircleRight } from "react-icons/fa";

export default function HomeBanner1(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);
	const [ bgIndex, setBgIndex ] = useState(0);
	const banners = [ banner1, banner2, banner3 ];

	async function init() {
		setReady(false);
		// initializations...
		setReady(true);
	}

	useEffect(() => {
		init();
	}, []);

	// Background transition effect
	useEffect(() => {
		if (!ready) return;

		const interval = setInterval(() => {
			setBgIndex(prev => (prev + 1) % banners.length);
		}, 2500); // change every 5 seconds

		return () => clearInterval(interval);
	}, [ready]);

	if (ready) {
		return (
			<div className="MainBodySection">
				<div
					style={{
						width: "100%",
						height: "calc(100vh - var(--topBarHeight))",
						position: "relative",
						overflow: "hidden"
					}}
				>
					{banners.map((banner, i) => (
						<div
							key={i}
							style={{
								backgroundImage: `url(${banner})`,
								backgroundAttachment: "fixed",
								backgroundSize: "cover",
								backgroundPosition: "center",
								width: "100%",
								height: "100%",
								position: "absolute",
								top: 0,
								left: 0,
								transition: "opacity 1.5s ease-in-out",
								opacity: i === bgIndex ? 1 : 0,
							}}
						/>
					))}

					{/* gradient overlay */}
					<div
						style={{
							width: "100%",
							height: "100%",
							background: "rgba(0, 0, 0, 0.65)",
							position: "relative",
							zIndex: 1
						}}
					>
						<div className="container">
							<div className="row">
								<div 
									className="col-md-6"
									style={{
										height: "150px"
									}}
								>

								</div>
								<div className="col-md-6">
									<h1
										className="font-bold text-light"
										style={{
											fontSize: "32px",
											paddingTop: "40px",
											textTransform: "uppercase",
										}}
									>
										Better Medical Equipments & Services
									</h1>

									<h1
										className="font-light text-light"
										style={{
											fontSize: "20px",
											paddingTop: "20px",
											paddingBottom: "10px",
										}}
									>
										Importation, Distribution & Maintenance of Medical Equipments
									</h1>


									<h1
										className="font-bold text-light"
										style={{
											fontSize: "16px",
										}}
									>
										<IoMdCheckmarkCircleOutline size={32} /> RADIOLOGY EQUIPEMENTS
									</h1>

									<h1
										className="font-bold text-light"
										style={{
											fontSize: "16px",
										}}
									>
										<IoMdCheckmarkCircleOutline size={32} /> HOSPITAL EQUIPMENTS
									</h1>
									
									<h1
										className="font-bold text-light"
										style={{
											fontSize: "16px",
										}}
									>
										<IoMdCheckmarkCircleOutline size={32} /> SUPPLY OF MEDICAL GAS
									</h1>

									
									
									
									<div className="text-end mt-5">
										<button
											className="btn btn-padded btn-rounded btn-primary"
											style={{
												margin: "10px",

											}}
											onClick={() => {
												appContext.navTo({
													item: 'about_us'
												})
											}}
										>
											About Us
										</button>

										<button
											className="btn btn-padded btn-rounded btn-outline-light"
											style={{
												margin: "10px",
												
											}}
											onClick={() => {
												appContext.navTo({
													item: 'about_us'
												})
											}}
										>
											Contact Us
										</button>
									</div>

								</div>

								

							</div>
						</div>
					</div>

				</div>
			</div>
		);
	} else {
		return (
			<div className="container mSupportLoading">
				{getInlineLoader()}
			</div>
		);
	}
}
